import { render, staticRenderFns } from "./tableText.vue?vue&type=template&id=09f12f42&scoped=true&"
import script from "./tableText.vue?vue&type=script&lang=ts&"
export * from "./tableText.vue?vue&type=script&lang=ts&"
import style0 from "./tableText.vue?vue&type=style&index=0&id=09f12f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f12f42",
  null
  
)

export default component.exports